import { Component } from '@angular/core';

@Component({
  selector: 'fgb-polls-layout-page',
  templateUrl: './polls-layout-page.component.html',
  styleUrl: './polls-layout-page.component.scss',
})
export class PollsLayoutPageComponent {}
